module.exports = __webpack_public_path__ + "static/media/social-icon-linkedin-blue.53097067.svg";